/**
 * `documents` — le coffre (base galerie, 4.1 et 3.5).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, idSchema, rattachementSchema, withAudit } from './commun.js';
/** Types de documents du coffre. */
export const TYPES_DOCUMENT = [
    'contrat_representation',
    'contrat_depot',
    'contrat_pret',
    'contrat_vente',
    'certificat',
    'facture',
    'avoir',
    'bon_depot',
    'bon_pret',
    'bon_transport',
    'constat_etat',
    'assurance',
    'fiche_oeuvre',
    'liste_prix',
    'offre',
    'provenance',
    'presse',
    'administratif',
    'autre',
];
export const typeDocumentSchema = z.enum(TYPES_DOCUMENT);
/**
 * Deux niveaux de confidentialité : ce que voit l'équipe, et ce qui n'est
 * ouvert qu'à la direction ou au droit fin « coffre confidentiel » (5.1).
 */
export const CONFIDENTIALITES = ['equipe', 'confidentiel'];
export const confidentialiteSchema = z.enum(CONFIDENTIALITES);
export const fichierSchema = z.object({
    cle: z.string().min(1),
    nom: z.string().min(1),
    typeMime: z.string().min(1),
    octets: z.int().min(0),
    depose: z.date(),
    deposePar: idSchema,
});
export const documentSchema = withAudit(z.object({
    _id: idSchema,
    type: typeDocumentSchema,
    titre: z.string().min(1),
    fichier: fichierSchema,
    /** Les versions précédentes, de la plus ancienne à la plus récente. */
    versions: z.array(fichierSchema).default([]),
    rattachements: z.array(rattachementSchema).default([]),
    confidentialite: confidentialiteSchema.default('equipe'),
    echeanceLe: z.date().optional(),
    /** Rappels en jours avant l'échéance : 90, 30, 7. */
    rappelsJours: z.array(z.int().min(0)).default([]),
    etiquettes: z.array(z.string()).default([]),
    archiveLe: z.date().optional(),
}));
export const documentCreationSchema = documentSchema.omit({
    ...CHAMPS_DOCUMENT,
    versions: true,
    archiveLe: true,
});
export const documentMiseAJourSchema = documentCreationSchema.omit({ fichier: true }).partial();
//# sourceMappingURL=documents.js.map